import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { MarkerSearchParams } from '../../marker-search-params';
import { Marker } from '../../marker';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-marker-list',
	templateUrl: './marker-list.component.html',
	styleUrls: [],
})
export class MarkerListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new MarkerSearchParams(this.route.snapshot.queryParams);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/marker',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: Marker) {
		this.router.navigateByUrl(`/marker/${item.getId()}`);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/marker/create']);
	}
	onCreateBulk() {
		this.router.navigate(['/marker/createbulk']);
	}
}
